import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ReactNode, useState, useEffect } from 'react';

// Only load Stripe when needed
let stripePromise: ReturnType<typeof loadStripe> | null = null;

const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    if (publishableKey && publishableKey !== 'pk_test_51234567890abcdef') {
      stripePromise = loadStripe(publishableKey);
    }
  }
  return stripePromise;
};

interface StripeProviderProps {
  children: ReactNode;
}

export function StripeProvider({ children }: StripeProviderProps) {
  const [stripe, setStripe] = useState<ReturnType<typeof loadStripe> | null>(null);

  useEffect(() => {
    // Only initialize Stripe if we're on a payment-related route
    const shouldInitializeStripe = window.location.pathname.includes('/subscription') || 
                                   window.location.pathname.includes('/payment');
    
    if (shouldInitializeStripe) {
      setStripe(getStripe());
    }
  }, []);

  return (
    <Elements stripe={stripe}>
      {children}
    </Elements>
  );
}